module.exports = __webpack_public_path__ + "static/media/40.2a4579d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wedding_engage/40.jpg
// module id = 249
// module chunks = 0